<template>
    <div>
        <div class="mb-1">
            <div class="form-check form-check-inline" v-if="with_parent_option">
                <label class="custom-cb">
                    <input type="checkbox" v-model="with_parent">
                    <span class="checkmark"></span>
                    {{ trans[locale].add_parent_at_same_time }}
                </label>
            </div>
            <div class="form-check form-check-inline" v-if="select_parent_by_student">
                <label class="custom-cb">
                    <input type="checkbox" v-model="select_parent_by_student" disabled >
                    <span class="checkmark"></span>
                    {{ trans[locale].select_parent_by_student }}
                </label>
            </div>
        </div>
        <table class="table table table-style2 table-striped with-edit ">
            <thead>
            <tr>
                <th>#</th>
                <th>{{ trans[locale].name }}</th>
                <th><a href="#" @click.prevent.stop="upRemoveAllAccount" class="btn-table-edit">
                    <i class="fas fa-trash-alt"></i>
                </a></th>
            </tr>
            </thead>
            <tbody v-if="no_of_selected_user > 0">
            <tr v-for="(user_item, key) in selected_users">
                <td>{{ key + 1 }}</td>
                <td v-if="typeof user_item.parent_name != 'undefined'">
                    {{ user_item.parent_name }}
                    <div class="small-txt">
                        {{ user_item.name }}
                    </div>
                </td>
                <td v-else>{{ user_item.name }}</td>
                <td>
                    <a href="#"
                       v-if="typeof user_item.locked == 'undefined' || !user_item.locked"
                       @click.prevent.stop="upRemoveSelectedAccount(user_item.key)" class="btn-table-edit">
                        <i class="fas fa-trash-alt"></i>
                    </a>
                </td>
            </tr>
            </tbody>
            <tbody v-else>
            <tr>
                <td colspan="3" class="text-center">{{ trans[locale].no_record }}</td>
            </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
    import { helperCommon } from "../../mixins/helper.common";
    export default {
        mixins: [ helperCommon ],
        name: "SelectedUserTable",
        data() {
            return Object.assign(
                {
                    trans: {
                        'zh-HK': {
                            'name': '名稱',
                            'no_record': '暫沒任何記錄',
                            'add_parent_at_same_time': '同時新增學生的家長',
                            'select_parent_by_student': '僅新增學生的家長',
                        },
                        'en': {
                            'name': 'name',
                            'no_record': 'No record at this moment',
                            'add_parent_at_same_time': 'Add parent(s) of students at the same time',
                            'select_parent_by_student': 'Add parent(s) of students only',
                        },
                    },
                    selected_users: this.init_selected_users,
                    component_name: this.$options.name,
                    with_parent: false,
                },
                { locale: window.locale }
            );
        },
        props: {
            is_debug: {
                required: false,
                type: Boolean,
                default: false
            },
            init_selected_users: {
                required: false,
                type: Array,
                default: () => {
                    return [];
                }
            },
            with_parent_option: {
                required: false,
                type: Boolean,
                default: false,
            },
            select_parent_by_student: {
                required: false,
                type: Boolean,
                default: false,
            },
        },
        beforeDestroy() {
            if (this.is_debug) this.debugMessage('*** BEFORE Destroy => [' + this.component_name + ']', 'warning');
            this.debug_info('warning');
            window.eventHub.$off('update-table-selected-users');
            window.eventHub.$off('retrieve-selected-user');
            window.eventHub.$off('retrieve-selected-user-with-param');
        },
        mounted() {
            if (this.is_debug) this.debugMessage('*** MOUNTED => [' + this.component_name + '] => mounted');
            this.debug_info();
            window.eventHub.$on('update-table-selected-users', (selected_users) => {
                this.selected_users = selected_users;
                if (this.is_debug) this.debugMessage('*** EVENT EMIT => [' + this.component_name + ']', 'success');
                this.debug_info('success');
            });

            window.eventHub.$on('retrieve-selected-user', (event_name) => {
                if (this.is_debug) this.debugMessage('*** EVENT EMIT => [' + this.component_name + '] => { retrieve-selected-user } => ' + event_name, 'success');
                this.debug_info('success');
                window.eventHub.$emit(event_name, this.selected_users);
            });

            window.eventHub.$on('retrieve-selected-user-with-param', (event_name, param) => {
                if (this.is_debug) this.debugMessage('*** EVENT EMIT => [' + this.component_name + '] => { retrieve-selected-user-with-param } => ' + event_name, 'success');
                this.debug_info('success');
                let parameters = {
                    with_parent: this.with_parent,
                    selected_users: this.selected_users
                };
                window.eventHub.$emit(event_name, parameters);
            });
        },
        methods : {
            debug_info(color_type) {
                if (this.is_debug) this.debugMessage('[' + this.component_name + '] : Selected users: ' + JSON.stringify(this.selected_users), color_type);
            },
            upRemoveAllAccount() {
                this.debug_info('error');
                this.selected_users = _.filter(this.selected_users, (user) => {
                    if (!_.isUndefined(user.locked) && user.locked)
                    {
                        return true;
                    } else {
                        return false;
                    }
                });
            },
            upRemoveSelectedAccount(key) {
                this.selected_users = _.filter(this.selected_users, (user) => {
                    if (user.key == key)
                    {
                        if (this.is_debug) this.debugMessage('[' + this.component_name + '] : Remove user: ' + JSON.stringify(user), 'error');
                    }
                    return user.key != key;
                });
                this.debug_info('error');
            }
        },
        watch: {
            init_selected_users: {
                handler(newVal) {
                    this.selected_users = this.init_selected_users;
                },
                deep: true
            },
            selected_users: {
                handler(newVal) {
                    /*
                    this event is using to bind value for v-model
                     */
                    // window.eventHub.$emit('update-picker-selected-users', this.selected_users);
                    this.$emit('input', this.selected_users);
                },
                deep: true
            }
        },
        computed: {
            no_of_selected_user() {
                return _.size(this.selected_users);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/UserPicker/SelectedUserTable.vue